import { cn } from "@/lib/utils";
import { AlertTriangle, CheckCircle, ShieldAlert, ShieldX } from "lucide-react";

type RiskLevel = "low" | "moderate" | "medium" | "high" | "critical";

interface RiskBadgeProps {
  level: RiskLevel;
  size?: "sm" | "md" | "lg";
}

const config: Record<RiskLevel, { label: string; icon: typeof CheckCircle; colorClass: string }> = {
  low: { label: "Low Risk", icon: CheckCircle, colorClass: "text-risk-low bg-risk-low/10 border-risk-low/30" },
  moderate: { label: "Moderate Risk", icon: AlertTriangle, colorClass: "text-risk-medium bg-risk-medium/10 border-risk-medium/30" },
  medium: { label: "Medium Risk", icon: AlertTriangle, colorClass: "text-risk-medium bg-risk-medium/10 border-risk-medium/30" },
  high: { label: "High Risk", icon: ShieldAlert, colorClass: "text-risk-high bg-risk-high/10 border-risk-high/30" },
  critical: { label: "Critical Risk", icon: ShieldX, colorClass: "text-risk-critical bg-risk-critical/10 border-risk-critical/30 animate-pulse-glow" },
};

const RiskBadge = ({ level, size = "md" }: RiskBadgeProps) => {
  const { label, icon: Icon, colorClass } = config[level];
  const sizeClasses = {
    sm: "px-2 py-1 text-xs gap-1",
    md: "px-3 py-1.5 text-sm gap-1.5",
    lg: "px-4 py-2 text-base gap-2",
  };

  return (
    <span className={cn("inline-flex items-center rounded-full border font-semibold", colorClass, sizeClasses[size])}>
      <Icon className={cn(size === "sm" ? "h-3 w-3" : size === "md" ? "h-4 w-4" : "h-5 w-5")} />
      {label}
    </span>
  );
};

export default RiskBadge;
export type { RiskLevel };
